import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/layout/Layout';
import Dashboard from './pages/Dashboard';
import Agents from './pages/Agents';
import VentureWorkspace from './pages/VentureWorkspace';
import DataVault from './pages/DataVault';
import Marketplace from './pages/Marketplace';
import Build from './pages/Build';
import People from './pages/People';
import Program from './pages/Program';
import Ventures from './pages/Ventures';
export function App() {
  const [userRole, setUserRole] = useState<'Program Manager' | 'Founder'>('Program Manager');
  const toggleRole = () => {
    setUserRole(prev => prev === 'Program Manager' ? 'Founder' : 'Program Manager');
  };
  return <Router data-id="element-0">
      <Layout userRole={userRole} toggleRole={toggleRole} data-id="element-1">
        <Routes data-id="element-2">
          <Route path="/" element={<Dashboard userRole={userRole} data-id="element-4" />} data-id="element-3" />
          <Route path="/agents" element={<Agents userRole={userRole} data-id="element-6" />} data-id="element-5" />
          <Route path="/ventures" element={<Ventures userRole={userRole} data-id="element-8" />} data-id="element-7" />
          <Route path="/ventures/:ventureId" element={<VentureWorkspace userRole={userRole} data-id="element-10" />} data-id="element-9" />
          <Route path="/data-vault" element={<DataVault userRole={userRole} data-id="element-12" />} data-id="element-11" />
          <Route path="/marketplace" element={<Marketplace userRole={userRole} data-id="element-14" />} data-id="element-13" />
          <Route path="/build" element={<Build userRole={userRole} data-id="element-16" />} data-id="element-15" />
          <Route path="/people" element={<People userRole={userRole} data-id="element-18" />} data-id="element-17" />
          <Route path="/program" element={<Program userRole={userRole} data-id="element-20" />} data-id="element-19" />
        </Routes>
      </Layout>
    </Router>;
}